import { Tooltip, Switch } from 'antd';
import { useAtom } from 'jotai';
import React, { useEffect } from 'react';
import { logAxisAtom } from '../atoms';
import { isMetricFilterAppliedSelector } from '@store/trends/base/selectors';
import { useSelector } from 'react-redux';

function LogAxis() {
  const isMetricFilterApplied = useSelector(isMetricFilterAppliedSelector);
  const [logAxis, setLogAxis] = useAtom(logAxisAtom);

  const handleClick = () => {
    const toggleValue = !logAxis;
    setLogAxis(toggleValue);
  }

  // revert to regular axis if SF is removed
  useEffect(() => {
    if(!isMetricFilterApplied) {
      setLogAxis(false);
    }
  }, [isMetricFilterApplied, setLogAxis]);

  return isMetricFilterApplied ? (
    <Tooltip title="Toggle log scale on y-axis">
      <Switch checkedChildren="Log Scale" unCheckedChildren="Log Scale" checked={logAxis} onChange={handleClick} />
    </Tooltip>
  ) : <></>
}

export default LogAxis;
